module.exports = __webpack_public_path__ + "0e4bccc1b3e265b9a8ca28152416d7b1.pdf";